<template>
    <section class="col-lg-3 order-1 order-lg-2">
        <!-- Sidebar Mobile -->
    <aside class="publication-details__sidebar sidebar--mobile d-lg-none ">
          <label
            class="publication-details__sidebar-heading"
            @click="toggleContent"
            for="sidebar-heading"
          >
            <div>
                {{ label }}

                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M11.9998 4.80005L11.9998 19.2M19.1998 12L4.7998 12" stroke="black" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
          </label>
  
          <section class="publication-details__sidebar-container">
            <!-- Toggle visibility of the list -->
            <ul v-if="showContent" class="publication-details__list">
              <li
               class="publication-details__list-item"
               v-for="(item, index) in keywords"
                :key="index"
                >{{ item }}
            </li>
            </ul>
          </section>
        </aside>

        <!-- Sidebar Desktop -->
        <aside class="publication-details__sidebar sidebar--desktop d-none d-lg-block">
          <label
            class="publication-details__sidebar-heading"
            for="sidebar-heading"
          >
            {{ label }}
          </label>
  
          <section class="publication-details__sidebar-container">
            <ul class="publication-details__list">
                <li
                class="publication-details__list-item"
                v-for="(item, index) in keywords"
                    :key="index"
                    >{{ item }}
                </li>
            </ul>
          </section>
        </aside>
    </section>
</template>
<script>
export default {
  data() {
    return {
      showContent: false, 
    };
  },
  methods: {
    toggleContent() {
      this.showContent = !this.showContent; 
    },
  },
  props: {
    label: {
      type: String,
      default: 'Keywords',
    },
    keywords: {
      type: Array,
      default: () => Array(10).fill('keyword'),
      validator: (value) => value.every((item) => typeof item === 'string'),
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/app/components/hcxf/hcxf-publication-details-facets.vue